import { Link } from "react-router-dom";
import { Phone, MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/api";
import QwLogo from "@/components/quickwash/QwLogo";

const Navbar = () => {
  const waLink = `https://wa.me/${BRAND.waPhone}?text=${encodeURIComponent("Hello Quick Wash, I need laundry service")}`;
  return (
    <header className="qw-glass-nav" data-testid="site-navbar">
      <div className="qw-container flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="brand-logo">
          <div className="transition-transform duration-300 group-hover:scale-110 group-hover:rotate-[-4deg]">
            <QwLogo size={40} />
          </div>
          <div className="leading-tight">
            <div className="font-extrabold text-slate-900 text-[17px] tracking-tight" style={{ fontFamily: 'Poppins' }}>Quick Wash</div>
            <div className="text-[10px] font-semibold uppercase tracking-[0.18em] text-emerald-600">Laundry · Drycleaners</div>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-1 text-sm">
          <Link to="/" className="qw-btn-ghost" data-testid="nav-home">Home</Link>
          <Link to="/book" className="qw-btn-ghost" data-testid="nav-book">Book Pickup</Link>
          <Link to="/track" className="qw-btn-ghost" data-testid="nav-track">Track Order</Link>
          <a href={`tel:${BRAND.phone}`} className="qw-btn-ghost" data-testid="nav-call"><Phone size={16}/>Call</a>
          <a href={waLink} target="_blank" rel="noreferrer" className="qw-btn-wa ml-2" data-testid="nav-whatsapp"><MessageCircle size={16}/>WhatsApp</a>
          <Link to="/login" className="qw-btn-primary ml-2" data-testid="nav-login">Billing Login</Link>
        </nav>
        <Link to="/login" className="md:hidden qw-btn-primary" data-testid="nav-login-mobile">Login</Link>
      </div>
    </header>
  );
};

export default Navbar;
